import React from 'react';
import {ScreenSpinner} from '@vkontakte/vkui';
import {PopoutId, PopoutProps} from './types';

const ScreenSpinnerPopout: React.FC<PopoutProps<PopoutId.SCREEN_SPINNER>> = () => <ScreenSpinner/>;

export default ScreenSpinnerPopout;
